
import {Component, Vue} from "vue-property-decorator";
import Account from './components/Account.vue';
import {
  alertModule,
  appSettingsModule,
  authModule,
  currentUserModule,
  ntdInstitutesModule,
  utilityModule
} from "@/store";
import {Alert} from "@/store/modules/alert";
import {eventBus} from "@/main";
import {MdbsCore} from "@/api/tsclient";
import {OnActive, OnIdle} from "vue-plugin-helper-decorator";
import {canAccessExports} from "@/auxillary/export.helper";
import Rights = MdbsCore.Rights;

@Component({
  methods: {canAccessExports},
  components: {
    Account
  },
})
export default class App extends Vue {

  drawer: any = null;

  get canUseAdministration() {
    return this.canEditUsers || this.canSeeNtdUsers || this.canEditInstitutes || this.canSeeNtdInstitutes
        || this.canSeeStudyDefinitionAdmin || this.canSeeDataMigrations;
  }

  get canSeeStudyDefinitionAdmin() {
    return currentUserModule.hasRight(Rights.ExportStudyDefinitionCmd) ||
        currentUserModule.hasRight(Rights.ExportStudySeederDefinitionCmd) ||
        currentUserModule.hasRight(Rights.ImportStudyDefinitionCmd) ||
        currentUserModule.hasRight(Rights.UpdateStudyDefinitionDatesCmd);
  }

  get canSeeDataMigrations() {
    return currentUserModule.hasRight(Rights.DataMigrationGetAllCmd);
  }

  get canSeeVisualization(){
    return currentUserModule.hasRight(Rights.AkromegalieGetVisualizationDataCmd) || currentUserModule.hasRight(Rights.AkromegalieGetMyVisualizationDataCmd);
  }

  get canEditUsers() {
    return currentUserModule.hasRight("UserGetAllCmd");
  }

  get canEditInstitutes() {
    return currentUserModule.hasRight("InstituteGetAllCmd");
  }

  get canSeeNtdInstitutes() {
    return ntdInstitutesModule.isOnline() &&
        (currentUserModule.hasRight(Rights.NtdInstituteGetAllCmd) ||
            currentUserModule.hasRight(Rights.NtdInstituteGetMyCmd));
  }

  get canSeeNtdUsers() {
    return ntdInstitutesModule.isOnline() && currentUserModule.hasRight(Rights.NtdUserGetAllCmd);
  }

  get canSeePatients() {
    return currentUserModule.hasRight("PatientGetAllCmd") || currentUserModule.hasRight("PatientGetMyCmd");
  }

  get canSeeInstituteOverview() {
    return (currentUserModule.hasRight(Rights.StudyInstituteOverviewGetAllCmd) || currentUserModule.hasRight(Rights.StudyInstituteOverviewGetMyCmd));
  }

  get canAccessSafetyReport() {
    return currentUserModule.hasRight(Rights.SafetyReportCmd);
  }

  get canSeeEventReportOverview() {
    return currentUserModule.hasRight(Rights.EventReportOverviewGetMyCmd);
  }

  get canSeeQueryOverview() {
    return currentUserModule.hasRight(Rights.QueryGetAllCmd) ||
        currentUserModule.hasRight(Rights.QueryGetAllForPatientCmd) ||
        currentUserModule.hasRight(Rights.QueryGetAllForVisitCmd) ||
        currentUserModule.hasRight(Rights.QueryGetAllForInstrumentCmd);
  }

  get canAccessDocumentation() {
    return currentUserModule.hasRight(
        Rights.DocumentationGetFunctionalDesignCmd ||
        Rights.DocumentationGetAnnotatedEcrfCmd ||
        Rights.DocumentationGetAnnotatedEcrfViewCmd);
  }

  get canSeeDocuments() {
    return currentUserModule.hasRight(Rights.DocumentGetAllCmd);
  }

  get canSeeCalendar() {
    return false;
  }

  get alerts() {
    return alertModule.alerts || []
  }

  get currentUser() {
    return currentUserModule.user;
  }

  get canSeeAppBar() {
    return this.currentUser != null;
  }

  get isDevEnvironment(): boolean {
    return ["DEMO", "DEV", "DEVELOPMENT"].includes(this.aspNetCoreEnvironment);
  }

  get aspNetCoreEnvironment(): string {
    return (utilityModule?.aspNetCoreEnvironment ?? "").toUpperCase();
  }

  async mounted() {
    await appSettingsModule.initialize();

    eventBus.$on("force-logout", async () => {
      if (this.$route.name == "login") {
        console.error("new page loaded")
        await alertModule.dismissAll();
      } else {
        console.warn("force logout from ", this.$route.name)
        await this.$router.push({name: "login"});
      }
    })
    if (authModule.loggedIn) {
      await currentUserModule.load();
    }
  }

  secondsUntilLogout = appSettingsModule.autoLogoutAfterWarn;
  idleInterval: number | null = null;

  @OnActive()
  public onActive() {
    if (!appSettingsModule.autoLogoutEnabled) return;

    if (this.idleInterval) {
      window.clearInterval(this.idleInterval);
      this.idleInterval = null;
    }
  }

  @OnIdle()
  async onIdle() {
    if (!appSettingsModule.autoLogoutEnabled) return;

    if (!currentUserModule.user) {
      this.onActive();
      return;
    }

    this.secondsUntilLogout = appSettingsModule.autoLogoutAfterWarn;
    this.idleInterval = window.setInterval(this.handleAutoLogout, 1000);
  }

  handleAutoLogout() {
    if (this.secondsUntilLogout > 0) {
      this.secondsUntilLogout--;
      return;
    }

    this.onActive();
    alertModule.info("Sie wurden automatisch abgemeldet.").then();
    this.logout().then();
  }


  get untilLogoutText() {
    if (!this.idleInterval || this.secondsUntilLogout > appSettingsModule.autoLogoutAfterWarn) return "";

    const minutesStr = Math.floor(this.secondsUntilLogout / 60);
    const seconds = Math.ceil(this.secondsUntilLogout % 60);
    const secondsStr = seconds < 10 ? "0" + seconds : seconds;

    return "Abmeldung in " + minutesStr + ":" + secondsStr;
  }

  async dismissAlert(alert: Alert) {
    alertModule.remove(alert)
  }

  async logout() {
    const route = await this.$router.push("/")
    if (route.name == "login") {
      await authModule.logout();
      // await currentUserModule.load();
    }
  }

  async goToHome() {
    if (currentUserModule.user != null)
      await this.$router.push({name: 'home'});
    else
      await this.$router.push("/")
  }
}
